/**
 * storage情報を扱うためのwrapperクラス
 * sessionStorage, localStorageを切り替えられるようにwrapperクラスとして本クラスは存在する
 */
class StorageManager {
  /**
   * 保存
   * @param {*} key
   * @param {*} value
   */
  static setItem (key, value) {
    this._checkKey(key)
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value)
    }
  }

  /**
   * 取得
   * @param {*} key
   */
  static getItem (key) {
    const data = localStorage.getItem(key)
    if (data === undefined || data === null) return null
    if (
      (data.startsWith('{') && data.endsWith('}')) ||
      (data.startsWith('[') && data.endsWith(']'))
    ) {
      return JSON.parse(data)
    }
    return localStorage.getItem(key)
  }

  /**
   * 削除
   * @param {*} key
   */
  static removeItem (key) {
    localStorage.removeItem(key)
  }

  static _checkKey (key) {
    const permits = ['OLPHEN_ACCESS_TOKEN', 'SIGN_IN_USER', 'ENUMS', 'MODE', 'ACCESS_URL']
    if (permits.indexOf(key) >= 0) {
      return true
    }
    throw new Error('Invalid Storage Key Detected')
  }
}

export default StorageManager
